import p from './zoomIn';

export * from './zoomIn';
export default p;
